import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-chart-pie",
  templateUrl: "./med-icon-chart-pie.component.html",
})
export class MedIconChartPieComponent extends SvgMixinComponent {}
